import type { Ref, WritableComputedRef } from 'vue';
import type { ResolvedMonospacePrimitiveField } from '#layers/data-model/public';
import { computed } from 'vue';
import { isPrimitiveTypeInteger64, parseInteger64Value } from '#layers/data-model/public';

/**
 * A JS-number view of a numeric field model that writes back in the field's own shape: 64-bit
 * integers are decimal strings. Only for controls whose values a double holds exactly.
 */
export function useNumberFormFieldModel(
	model: WritableComputedRef<number | string | null | undefined>,
	field: Ref<ResolvedMonospacePrimitiveField | undefined>,
) {
	return computed({
		get: () => {
			if (model.value == null || model.value === '') return;
			const value = Number(model.value);
			return Number.isFinite(value) ? value : undefined;
		},
		set: (value: number | null | undefined) => {
			const type = field.value?.type;

			if (value == null || !type || !isPrimitiveTypeInteger64(type)) {
				model.value = value;
				return;
			}

			const integer = parseInteger64Value(value, type.name);
			if (integer !== undefined) model.value = integer;
		},
	});
}
